// @flow
// TODO: Consider refactoring this file to reduce complexity.
import moment from 'moment';
import {
  WHITELIST_TURBO_BANNER_STAGING,
  WHITELIST_TURBO_CAMPAIGN_PRODUCTION
} from './whitelist-turbo-campaign';

export const WHITELIST_TURBO_STAGING = [
  'bc-dev-v2-iris10.myshopify.com',
  'bc-dev-erin.myshopify.com',
  'bc-dev-ellie-test.myshopify.com',
  'bc-dev-v2-clara02.myshopify.com',
  'bc-dev-v2-helen3.myshopify.com'
];

export const WHITELIST_TURBO_V2_STAGING = [
  'bc-dev-v2-iris9.myshopify.com',
  'bc-dev-v2-jena12.myshopify.com'
];

export const LIST_TENANT_NOT_SHOW_MODAL = [
  '9313ca-2.myshopify.com',
  'c9f955-3.myshopify.com',
  'castoreaus.myshopify.com',
  'chicoryhome.myshopify.com',
  'ecanta.myshopify.com',
  'keitoya.myshopify.com',
  'loomandloft2.myshopify.com',
  'nomax-norway.myshopify.com',
  'root-and-blow.myshopify.com',
  'yakirabella.myshopify.com'
];

export const WHITELIST_TURBO_PRODUCTION = [
  '00878d-5e.myshopify.com',
  '019d6b-3.myshopify.com',
  '035cf4-f8.myshopify.com',
  '0527f0.myshopify.com',
  '082007.myshopify.com',
  '0riginalfeet.myshopify.com',
  '12c7b7.myshopify.com',
  '0e9a24-2.myshopify.com',
  '13606c-3.myshopify.com',
  '110528-3.myshopify.com',
  '10b613-3.myshopify.com',
  '1395c7.myshopify.com',
  '178602.myshopify.com',
  '178242-3.myshopify.com',
  '1cc8fc-3.myshopify.com',
  '1b1951.myshopify.com',
  '0935f9.myshopify.com',
  '1c912d-2.myshopify.com',
  '1b32ec-d8.myshopify.com',
  '207650-5.myshopify.com',
  '22117b.myshopify.com',
  '21edfd-2.myshopify.com',
  '26557c-c6.myshopify.com',
  '256503.myshopify.com',
  '243c24.myshopify.com',
  '28e677.myshopify.com',
  '2ac1b1-2.myshopify.com',
  '2amstudioofficial.myshopify.com',
  '2e813f.myshopify.com',
  '2f4da2.myshopify.com',
  '291203-2.myshopify.com',
  '2nd-to-none-co.myshopify.com',
  '318e42-78.myshopify.com',
  '35286a-4.myshopify.com',
  '365fb2-2.myshopify.com',
  '322d0a.myshopify.com',
  '39a796.myshopify.com',
  '3bb54e.myshopify.com',
  '3aec80-2.myshopify.com',
  '34405b-4.myshopify.com',
  '37633b-2.myshopify.com',
  '374a6a-2.myshopify.com',
  '33d38e-3.myshopify.com',
  '3f351c-2.myshopify.com',
  '3d0f81-2.myshopify.com',
  '430fa6-3.myshopify.com',
  '3dverkstandk.myshopify.com',
  '3b0e99.myshopify.com',
  '4cb897-2.myshopify.com',
  '46d8a4-2.myshopify.com',
  '4ddba9-3.myshopify.com',
  '49db8b-3.myshopify.com',
  '4f1b22-3.myshopify.com',
  '50ab7c.myshopify.com',
  '520892-2.myshopify.com',
  '502fdb.myshopify.com',
  '54769c-2.myshopify.com',
  '568a79-5.myshopify.com',
  '575575-2.myshopify.com',
  '510ed7-3.myshopify.com',
  '5558ad.myshopify.com',
  '559490-3.myshopify.com',
  '58d456.myshopify.com',
  '5c6a3f.myshopify.com',
  '59e932-4.myshopify.com',
  '611ebf-2.myshopify.com',
  '5f2e5c-2.myshopify.com',
  '569af1-5.myshopify.com',
  '5c6e7b-2.myshopify.com',
  '64ad96.myshopify.com',
  '67acdb-3.myshopify.com',
  '686bea.myshopify.com',
  '683b14.myshopify.com',
  '6af8cd-2.myshopify.com',
  '66a0a0-2.myshopify.com',
  '6c5f63-3.myshopify.com',
  '6ec90d-e1.myshopify.com',
  '6c3482.myshopify.com',
  '6f3b99-3.myshopify.com',
  '730558-2.myshopify.com',
  '736bc9.myshopify.com',
  '753653-2.myshopify.com',
  '73871b.myshopify.com',
  '77d122-3.myshopify.com',
  '70f8a8.myshopify.com',
  '76b0b2.myshopify.com',
  '79510b-2.myshopify.com',
  '79643b-3.myshopify.com',
  '7a5637.myshopify.com',
  '6aa06b-2.myshopify.com',
  '7db659-3.myshopify.com',
  '777fd5-b7.myshopify.com',
  '7e7e84.myshopify.com',
  '77b32a-3.myshopify.com',
  '86f6a5.myshopify.com',
  '86fce4.myshopify.com',
  '85c303.myshopify.com',
  '889fb7-2.myshopify.com',
  '88cd40-3.myshopify.com',
  '8a5a6c-3.myshopify.com',
  '8dio-com.myshopify.com',
  '8dd734-5.myshopify.com',
  '8b922c.myshopify.com',
  '8d2bd1.myshopify.com',
  '8f8c03.myshopify.com',
  '901f3c.myshopify.com',
  '922290-2.myshopify.com',
  '925fd1-5.myshopify.com',
  '93f5af.myshopify.com',
  '97e80e-3.myshopify.com',
  '973e35-3.myshopify.com',
  '94e05e-2.myshopify.com',
  '9ba1c6.myshopify.com',
  '9c8c79.myshopify.com',
  '9e54de.myshopify.com',
  '9e145c-99.myshopify.com',
  '982bb1-2.myshopify.com',
  '9c04c0-2.myshopify.com',
  'a1aefd.myshopify.com',
  'a2e1e1-2.myshopify.com',
  'a1598b-2.myshopify.com',
  'a218a4-2.myshopify.com',
  'a4eb82-2.myshopify.com',
  'a8c46d-4.myshopify.com',
  '9ef9b1.myshopify.com',
  'a54b8f.myshopify.com',
  'a37ec4-3.myshopify.com',
  'a566e1-3.myshopify.com',
  'abf746-5.myshopify.com',
  'accio-box.myshopify.com',
  '90f24f-3.myshopify.com',
  'ackerbaum.myshopify.com',
  'ad759b.myshopify.com',
  'aadyaa-originals-pvt-ltd.myshopify.com',
  'adorevintagecanada.myshopify.com',
  'aed-team.myshopify.com',
  'aiage23.myshopify.com',
  'accessorizelondon.myshopify.com',
  'albercas-y-punto.myshopify.com',
  'alastin.myshopify.com',
  'alltrueist.myshopify.com',
  'airthreads.myshopify.com',
  'altitude-authentics.myshopify.com',
  'amavi-mm.myshopify.com',
  'amicciuk.myshopify.com',
  'alkemispaint.myshopify.com',
  'anchoredbylove.myshopify.com',
  'angel-brinks.myshopify.com',
  'animalpride-com.myshopify.com',
  'apreseveryday.myshopify.com',
  'arpar-shop.myshopify.com',
  'artblownstore.myshopify.com',
  'asia-minor-carpets.myshopify.com',
  'atelier-yuka-photo-wedding.myshopify.com',
  'australian-cookie-cutters.myshopify.com',
  'authenticstreetsigns.myshopify.com',
  'av-uruguay.myshopify.com',
  'ava-the-brand.myshopify.com',
  'b12454-2.myshopify.com',
  'b10631-3.myshopify.com',
  'away-that-day.myshopify.com',
  'b32973-4.myshopify.com',
  'b77d40-85.myshopify.com',
  'ba084c.myshopify.com',
  'babe-new.myshopify.com',
  'ba1b4d.myshopify.com',
  'babyhouse-australia.myshopify.com',
  'badpeaches.myshopify.com',
  'ballantynes-jewellers.myshopify.com',
  'bc-prod-v3-pm.myshopify.com',
  'bdc21b-2.myshopify.com',
  'beaver-snax.myshopify.com',
  'bebf3d-2.myshopify.com',
  'bee29e-2.myshopify.com',
  'bella-epoca-zapateria.myshopify.com',
  'bellino-gems.myshopify.com',
  'bento-gaming-ca.myshopify.com',
  'best-collection-boutique.myshopify.com',
  'bettababy.myshopify.com',
  'bestknifestore.myshopify.com',
  'bicisportchile.myshopify.com',
  'billini1.myshopify.com',
  'billsons-beechworth.myshopify.com',
  'blacfundsmatter.myshopify.com',
  'blackbear-boutique.myshopify.com',
  'blueridgeoutfitters.myshopify.com',
  'blongser.myshopify.com',
  'bmc-bikes-inc.myshopify.com',
  'boboandbooau.myshopify.com',
  'bonita-de-mas.myshopify.com',
  'blue-sky-scrubs.myshopify.com',
  'blissy-brand.myshopify.com',
  'boost-pfs-test-sarah02.myshopify.com',
  'bosch-pt-ro.myshopify.com',
  'boost-pfs-test-kaylee02.myshopify.com',
  'boost-sd-dev-test-paola.myshopify.com',
  'boost-pfs-test-v3-amy.myshopify.com',
  'boutique-bella-blue.myshopify.com',
  'box-of-books-prod.myshopify.com',
  'branch-and-vines.myshopify.com',
  'braingain2.myshopify.com',
  'boycott-1.myshopify.com',
  'brands-establishment.myshopify.com',
  'box-babe-gift-co.myshopify.com',
  'brand-ring.myshopify.com',
  'brandtokyo-jp.myshopify.com',
  'boost-pfs-test-v3-sunny.myshopify.com',
  'brandsmegastore.myshopify.com',
  'brew-culture-craft-brewing-supplies.myshopify.com',
  'bremner-tcg.myshopify.com',
  'brooklyn-bred-since-1930.myshopify.com',
  'broadway-limited-imports.myshopify.com',
  'bravobraboutique.myshopify.com',
  'bull-and-briar-leather-llc.myshopify.com',
  'bunker-hill-design-plllc.myshopify.com',
  'burdlife.myshopify.com',
  'c25671-2.myshopify.com',
  'c0e1b2.myshopify.com',
  'c2-paint.myshopify.com',
  'c625e7-3.myshopify.com',
  'c4b644-2.myshopify.com',
  'c86883-3.myshopify.com',
  'c705b6.myshopify.com',
  'c2bac0-3.myshopify.com',
  'c7f707.myshopify.com',
  'c90ad5-2.myshopify.com',
  'c8a643-3.myshopify.com',
  'cabinet-hardware-specialties.myshopify.com',
  'caffetteria-stazione.myshopify.com',
  'c9b83e-3.myshopify.com',
  'c7d614.myshopify.com',
  'cap-rouge.myshopify.com',
  'capusanyc.myshopify.com',
  'carstomised.myshopify.com',
  'carrdan-preservation-supply.myshopify.com',
  'cb11de-2.myshopify.com',
  'cce3f2-3.myshopify.com',
  'carner-bcn.myshopify.com',
  'chargit-store.myshopify.com',
  'chippindale-plant.myshopify.com',
  'ciano-farmer-denim-co.myshopify.com',
  'ciss-cola.myshopify.com',
  'clb-xxiii.myshopify.com',
  'cokerexpo.myshopify.com',
  'collegiatepulse.myshopify.com',
  'colorado-canyon-enthusiasts.myshopify.com',
  'colmoda-usa.myshopify.com',
  'commit-watch.myshopify.com',
  'contrast-living.myshopify.com',
  'compression-socks-fdm.myshopify.com',
  'contact-225.myshopify.com',
  'consequence-store.myshopify.com',
  'contact-675.myshopify.com',
  'comfort-company-inc.myshopify.com',
  'coughy.myshopify.com',
  'courtneyscandles1992.myshopify.com',
  'cover-corp.myshopify.com',
  'cramerco.myshopify.com',
  'craniologie-llc.myshopify.com',
  'creature-racing-parts.myshopify.com',
  'crossfor.myshopify.com',
  'cutting-tool-pickers-1.myshopify.com',
  'cwjewellers.myshopify.com',
  'd0a140.myshopify.com',
  'd-estetika.myshopify.com',
  'd72a77-4.myshopify.com',
  'd76af7-3.myshopify.com',
  'd5704e.myshopify.com',
  'd9daeb-04.myshopify.com',
  'd3bae9-2.myshopify.com',
  'daintydiamond.myshopify.com',
  'dasbootleg.myshopify.com',
  'dc6efa-5.myshopify.com',
  'dbf909.myshopify.com',
  'dd651e.myshopify.com',
  'dansonjewelers.myshopify.com',
  'demakers.myshopify.com',
  'deniliquin-jewellers.myshopify.com',
  'devine-lux-clothing-apparel.myshopify.com',
  'dfa66a-3.myshopify.com',
  'df11d1-3.myshopify.com',
  'digger-tactical-australia.myshopify.com',
  'dirbhos.myshopify.com',
  'direct-hemp-distributor.myshopify.com',
  'dispatchtalent-4709-2.myshopify.com',
  'djbox-ie-dj-shop.myshopify.com',
  'doghouse-distillery-new-build.myshopify.com',
  'domestic-spare-parts.myshopify.com',
  'doorsforsale.myshopify.com',
  'dripcityjewellers.myshopify.com',
  'dubai-jewellers-2226.myshopify.com',
  'dwell-home-market.myshopify.com',
  'e01316-3.myshopify.com',
  'e2054b.myshopify.com',
  'e3eb06-91.myshopify.com',
  'e2a613.myshopify.com',
  'e4aa55-2.myshopify.com',
  'e4c146-2.myshopify.com',
  'e48fbd-2.myshopify.com',
  'e4c47f-2.myshopify.com',
  'e654c3.myshopify.com',
  'e9b14d.myshopify.com',
  'ebiketechnology.myshopify.com',
  'echo-boutique-im.myshopify.com',
  'ecommerceworld1.myshopify.com',
  'ee7944-2.myshopify.com',
  'ef7b89.myshopify.com',
  'eddiebauer-jp.myshopify.com',
  'element-tattoo-supplies.myshopify.com',
  'elitejerseys-1394.myshopify.com',
  'elodie-details-uae.myshopify.com',
  'elkthelabel-us.myshopify.com',
  'enspiredby.myshopify.com',
  'espresso-planet-staging.myshopify.com',
  'epochlax.myshopify.com',
  'etonic1876.myshopify.com',
  'evengreener.myshopify.com',
  'eventsinabox.myshopify.com',
  'evanhealy.myshopify.com',
  'f0fef8.myshopify.com',
  'f145f0-4.myshopify.com',
  'f5a925-2.myshopify.com',
  'f8bc06.myshopify.com',
  'f5d096-2.myshopify.com',
  'fa03ce.myshopify.com',
  'facemeetcp.myshopify.com',
  'fancy-sunglasses-shop.myshopify.com',
  'fc3821.myshopify.com',
  'fenton-and-co.myshopify.com',
  'fipsas22.myshopify.com',
  'floridafreedivers.myshopify.com',
  'fne-the-brand.myshopify.com',
  'fox-racing-en-mexico.myshopify.com',
  'frau-kauf.myshopify.com',
  'foxchapel.myshopify.com',
  'fraktal-si.myshopify.com',
  'fractal-designs-london-ontario.myshopify.com',
  'freshskis.myshopify.com',
  'frockandfrill.myshopify.com',
  'fresh-n-marine-aquarium.myshopify.com',
  'funkychunky-promo.myshopify.com',
  'garden-fountains.myshopify.com',
  'garage89-1009-3.myshopify.com',
  'ganemjewelers.myshopify.com',
  'gem-center-usa-wholesale.myshopify.com',
  'get-rhino-protected.myshopify.com',
  'gioielleria-capodagli.myshopify.com',
  'gloskin-beauty.myshopify.com',
  'glowdecor.myshopify.com',
  'global-picollet.myshopify.com',
  'go-sleek-salon.myshopify.com',
  'goruck-demo.myshopify.com',
  'gospaorg.myshopify.com',
  'gracia-kids-1890.myshopify.com',
  'golf-cart-people.myshopify.com',
  'granvia-linea.myshopify.com',
  'great-trango-holdings-inc.myshopify.com',
  'gruponosaracr.myshopify.com',
  'hairlaya.myshopify.com',
  'hand-me-upp.myshopify.com',
  'hammerbacher.myshopify.com',
  'happyaslarrydesigns.myshopify.com',
  'happysoaps-se.myshopify.com',
  'heartypet.myshopify.com',
  'heest.myshopify.com',
  'hellbent-performance-products.myshopify.com',
  'heydudeshoes.myshopify.com',
  'hbloch.myshopify.com',
  'herzog-jewelers.myshopify.com',
  'hobbyhorseinc.myshopify.com',
  'his-way-herenmode.myshopify.com',
  'holders-diesel-performance.myshopify.com',
  'hololive.myshopify.com',
  'hugglehounds.myshopify.com',
  'houseandhomestyle1.myshopify.com',
  'house-of-glemore.myshopify.com',
  'hustlingshop.myshopify.com',
  'i-am-woman-sa.myshopify.com',
  'hydrogenperoxide.myshopify.com',
  'i-am-eva-period-proof-underwear.myshopify.com',
  'ikt-boutique.myshopify.com',
  'impactcoach.myshopify.com',
  'imi-jewelery-demo.myshopify.com',
  'ikkari-development.myshopify.com',
  'inkspire-japan.myshopify.com',
  'ipanemasouthafrica.myshopify.com',
  'invotech-mx-online.myshopify.com',
  'jackall-online-shop.myshopify.com',
  'irvine-art-and-music.myshopify.com',
  'jacques-specialists.myshopify.com',
  'jaes-jewelers.myshopify.com',
  'jackfruitfurniture.myshopify.com',
  'jacintatienda.myshopify.com',
  'jigsaw-puzzles-direct.myshopify.com',
  'jj-ag-parts.myshopify.com',
  'joey-the-label.myshopify.com',
  'jp-rituals.myshopify.com',
  'jtm-auto-4x4-parts-accessories.myshopify.com',
  'kairyushop.myshopify.com',
  'kamashoinc-2.myshopify.com',
  'kateliva.myshopify.com',
  'kandakirat.myshopify.com',
  'kb-ottawa-plants.myshopify.com',
  'kd-solar.myshopify.com',
  'keelaoutdoors.myshopify.com',
  'kala-marmoles.myshopify.com',
  'key-compostables.myshopify.com',
  'kerata.myshopify.com',
  'kickback-shoes.myshopify.com',
  'koraru-store.myshopify.com',
  'knowthedrills.myshopify.com',
  'konkurspriserse.myshopify.com',
  'labelsbythebay.myshopify.com',
  'la-uniformeria.myshopify.com',
  'lady-epis-shoppe.myshopify.com',
  'langerchen.myshopify.com',
  'lance-co-jewelers.myshopify.com',
  'lagattaconglistivali-store.myshopify.com',
  'langolodellemeraviglie.myshopify.com',
  'lay-it-flat.myshopify.com',
  'lecoqsportifsa.myshopify.com',
  'legit-grit.myshopify.com',
  'linefurnituredenmark.myshopify.com',
  'lichttechnik24-de.myshopify.com',
  'liquorstoretest.myshopify.com',
  'linefurnituregroup.myshopify.com',
  'livinlinens.myshopify.com',
  'lithos-diamonds.myshopify.com',
  'loomandloft.myshopify.com',
  'loop-plus-bow.myshopify.com',
  'lovebycomo.myshopify.com',
  'loon-outdoors.myshopify.com',
  'luchs-vn.myshopify.com',
  'ltlparts.myshopify.com',
  'lunalaeb2b.myshopify.com',
  'luum-textiles-dev.myshopify.com',
  'lumi-lighting.myshopify.com',
  'madoneco.myshopify.com',
  'maison-venu-7432.myshopify.com',
  'mamasuncut-store.myshopify.com',
  'manore-shop.myshopify.com',
  'markcross1845.myshopify.com',
  'love-in-faith.myshopify.com',
  'mattressmattresstore.myshopify.com',
  'mechioau.myshopify.com',
  'mega-brown-box.myshopify.com',
  'meg-lizabet.myshopify.com',
  'mays-jewellery.myshopify.com',
  'mff-stg-easyspirit.myshopify.com',
  'michelle-accesorios-4383.myshopify.com',
  'menmomswebstore.myshopify.com',
  'mikisapiy.myshopify.com',
  'minjion.myshopify.com',
  'milemarkerinc.myshopify.com',
  'misssunshinenailss.myshopify.com',
  'minter-and-richter-designs.myshopify.com',
  'mobuofficial.myshopify.com',
  'mixperfume.myshopify.com',
  'moms-the-word-2.myshopify.com',
  'monitaya.myshopify.com',
  'monkeycatde.myshopify.com',
  'morrison-dev.myshopify.com',
  'morrisonaustralia.myshopify.com',
  'more-loop.myshopify.com',
  'monisha-melwani-jewelry.myshopify.com',
  'mount-vernon-coin.myshopify.com',
  'mr-indeva.myshopify.com',
  'moral-code-store.myshopify.com',
  'mundo-outdoors-shop.myshopify.com',
  'murray2019.myshopify.com',
  'movewithbluee.myshopify.com',
  'mureta-co.myshopify.com',
  'mutual-muse.myshopify.com',
  'mysamsungstraps.myshopify.com',
  'myriadbeautystore.myshopify.com',
  'mynewcastle.myshopify.com',
  'mystudio206.myshopify.com',
  'nailster-norway.myshopify.com',
  'nailster-sweden.myshopify.com',
  'nally-jewels.myshopify.com',
  'nailster-denmark.myshopify.com',
  'na-development-store.myshopify.com',
  'naudic.myshopify.com',
  'native-linum.myshopify.com',
  'nbluxe-us.myshopify.com',
  'nerd-stuff-of-alabama.myshopify.com',
  'nerias.myshopify.com',
  'new-enerj.myshopify.com',
  'nice-car-collections.myshopify.com',
  'nigel-rayment-boutiques.myshopify.com',
  'nnn-uae-global.myshopify.com',
  'noelathome.myshopify.com',
  'nordbythomsen.myshopify.com',
  'nosix-co-uk.myshopify.com',
  'nutramedix-products.myshopify.com',
  'ob-vape.myshopify.com',
  'o13-x-thewoods.myshopify.com',
  'okeycasual.myshopify.com',
  'oh-thanks.myshopify.com',
  'olokuti.myshopify.com',
  'omakase-tokyo.myshopify.com',
  'organax-6434.myshopify.com',
  'otiumberg.myshopify.com',
  'orase.myshopify.com',
  'ourhomehaus.myshopify.com',
  'outdoorkid-pl.myshopify.com',
  'ovais-abaya-collection-store.myshopify.com',
  'outletstore24a.myshopify.com',
  'oway-b2c.myshopify.com',
  'pacificboardertest.myshopify.com',
  'paddockperformance.myshopify.com',
  'panayotis.myshopify.com',
  'paper-and-grace.myshopify.com',
  'papercrush-de.myshopify.com',
  'pappos-mx.myshopify.com',
  'pandp-3.myshopify.com',
  'parrotstation-com.myshopify.com',
  'parfum-exquis-us.myshopify.com',
  'parkside-skateshop.myshopify.com',
  'pepcell-sa.myshopify.com',
  'pell-1990.myshopify.com',
  'peintio.myshopify.com',
  'pet-natural-store.myshopify.com',
  'petit-seal.myshopify.com',
  'petit-collage.myshopify.com',
  'pfaa2u.myshopify.com',
  'pixusjacquelinesscrubs.myshopify.com',
  'pixusmerseyflooring.myshopify.com',
  'plain-jane-shop.myshopify.com',
  'pixusfashionsznnew.myshopify.com',
  'plastic-world-solutions.myshopify.com',
  'plants-for-humans.myshopify.com',
  'pmr-customs.myshopify.com',
  'plug-and-playy.myshopify.com',
  'poe-net.myshopify.com',
  'pod-shoes.myshopify.com',
  'porsche-japan.myshopify.com',
  'pre-packs.myshopify.com',
  'precorhomefitness.myshopify.com',
  'premium-diagnostics.myshopify.com',
  'prestigeclt.myshopify.com',
  'professional-jewelers.myshopify.com',
  'pro-australia.myshopify.com',
  'pws-dev-ca.myshopify.com',
  'pure-cotton-comfort.myshopify.com',
  'rainsisters.myshopify.com',
  'rashidcassimsports.myshopify.com',
  'raxautos.myshopify.com',
  'rcawd.myshopify.com',
  're-fabbed.myshopify.com',
  'rebrand-trading.myshopify.com',
  'reflo-athleisure.myshopify.com',
  'respiro-indonesia.myshopify.com',
  'retail-boyz-shop.myshopify.com',
  'resistol.myshopify.com',
  'rewinddesign.myshopify.com',
  'reuplane.myshopify.com',
  'rodeoh-b2b.myshopify.com',
  'roma-customers.myshopify.com',
  'roland-sands-design-4611.myshopify.com',
  'roseandthorne.myshopify.com',
  'rosery-flowers.myshopify.com',
  'rtfbikeparts.myshopify.com',
  'rubino-shoehub.myshopify.com',
  'rv6-wholesale.myshopify.com',
  'safety-giant.myshopify.com',
  'rotatechproducts.myshopify.com',
  'sabellah.myshopify.com',
  'sabasnet.myshopify.com',
  'saltaire-antiques.myshopify.com',
  'salwarstudio.myshopify.com',
  'scents-284.myshopify.com',
  'scorpifyus.myshopify.com',
  'scoutandrebel.myshopify.com',
  'secondhandkiste.myshopify.com',
  'satoyaku.myshopify.com',
  'seven-mx-canada.myshopify.com',
  'seeeyewear.myshopify.com',
  'sewsoutherndesigns1.myshopify.com',
  'sg-fashiontofigure.myshopify.com',
  'sg-nyandco.myshopify.com',
  'shop-sole-therapy.myshopify.com',
  'shop-chevalier.myshopify.com',
  'shop-online-timack.myshopify.com',
  'shopnyra.myshopify.com',
  'shopxclusivesneakers.myshopify.com',
  'shuggie-co.myshopify.com',
  'shoprecordstore.myshopify.com',
  'sikhestperformance.myshopify.com',
  'sillou.myshopify.com',
  'simplyfashion-no.myshopify.com',
  'site-garant.myshopify.com',
  'skatescool-shop.myshopify.com',
  'skullvikings.myshopify.com',
  'skora-australia.myshopify.com',
  'slam-next.myshopify.com',
  'sky-manor.myshopify.com',
  'sk-belleza.myshopify.com',
  'sm-ca-shop.myshopify.com',
  'sm-wisetekusa.myshopify.com',
  'socksrock.myshopify.com',
  'soin-de-toi.myshopify.com',
  'snow-moon-press-shop.myshopify.com',
  'sokkat.myshopify.com',
  'sophias-costume.myshopify.com',
  'solovintage-jp.myshopify.com',
  'soundpaint.myshopify.com',
  'solidstateprints.myshopify.com',
  'southern-drawl-store.myshopify.com',
  'splay-outlet.myshopify.com',
  'speedcubing-org.myshopify.com',
  'sport-vl-2-0.myshopify.com',
  'spray-foam-equipment.myshopify.com',
  'sportsleisureau.myshopify.com',
  'spreezer.myshopify.com',
  'stagingxplct.myshopify.com',
  'star-luxury-vintage.myshopify.com',
  'staging4hiyaku.myshopify.com',
  'stayhumanonearth.myshopify.com',
  'still-here-new-york.myshopify.com',
  'state-of-escape.myshopify.com',
  'steel-barnett.myshopify.com',
  'steep-mountain-tea.myshopify.com',
  'sticky-black-tarmac.myshopify.com',
  'stienhard-stones.myshopify.com',
  'strut-menwear.myshopify.com',
  'sugarboxusa.myshopify.com',
  'style-mouktika.myshopify.com',
  'sujimyshopify.myshopify.com',
  'sugistrading-dev.myshopify.com',
  'sugistrading-tw.myshopify.com',
  'sunsum-intention-candles.myshopify.com',
  'suzysfine-jewellery.myshopify.com',
  'swell-wellness.myshopify.com',
  'sziro-jewelry.myshopify.com',
  'takonyan.myshopify.com',
  'tangollector.myshopify.com',
  'take-five-trading.myshopify.com',
  'tbn-db-nz.myshopify.com',
  'teakunique.myshopify.com',
  'teq-customs-llc.myshopify.com',
  'testshopoasis.myshopify.com',
  'thai-vape-shop.myshopify.com',
  'the-boot-jack.myshopify.com',
  'the-decorators-1949.myshopify.com',
  'the-freeze-dried-candy-store-wholesale.myshopify.com',
  'the-irish-flute-store.myshopify.com',
  'the-mens-room-shop.myshopify.com',
  'the-perfect-workout-8102.myshopify.com',
  'the-rail-ph.myshopify.com',
  'the-thrifting-den.myshopify.com',
  'the-union-project-2-0.myshopify.com',
  'theecommkid.myshopify.com',
  'thegemflystore.myshopify.com',
  'theyorkshirejigsawstore.myshopify.com',
  'thesint.myshopify.com',
  'thepets-dk.myshopify.com',
  'thestonemart.myshopify.com',
  'tifosi-optics.myshopify.com',
  'tn-americas.myshopify.com',
  'togah.myshopify.com',
  'tienda-multimax.myshopify.com',
  'tmkbeauty.myshopify.com',
  'toad-co-golden.myshopify.com',
  'toledo-dealer-services.myshopify.com',
  'tolly-toys.myshopify.com',
  'tonerprofis24.myshopify.com',
  'topologiejp.myshopify.com',
  'topologiestaging.myshopify.com',
  'tr-beegoddess.myshopify.com',
  'tracmaster.myshopify.com',
  'trendsbeautyaustraliaaa.myshopify.com',
  'trusports-in.myshopify.com',
  'turquoiselane.myshopify.com',
  'twelveboardstore.myshopify.com',
  'twgtea.myshopify.com',
  'txcom-ads.myshopify.com',
  'twisted-thread.myshopify.com',
  'uk-water-filters.myshopify.com',
  'um-x-flanci.myshopify.com',
  'upmarket-scents.myshopify.com',
  'unicorn-egg.myshopify.com',
  'used-legends-direct.myshopify.com',
  'vactam.myshopify.com',
  'uyeki-online-shop.myshopify.com',
  'vanezia.myshopify.com',
  'velaireat.myshopify.com',
  'us-alterraretail.myshopify.com',
  'verb-by-pallavi-singhee.myshopify.com',
  'vividads-com-au.myshopify.com',
  'vinod-patel-fiji.myshopify.com',
  'vitaman-usa.myshopify.com',
  'voda-flooring.myshopify.com',
  'voda-boutique.myshopify.com',
  'volcano-gaming-8840.myshopify.com',
  'voilondon-me.myshopify.com',
  'vulcan-grips.myshopify.com',
  'vulkan.myshopify.com',
  'wallpaper-trader.myshopify.com',
  'walker-wade.myshopify.com',
  'wagtail-is.myshopify.com',
  'vrjewels-us.myshopify.com',
  'we-got-that-juice.myshopify.com',
  'watts-oguchi.myshopify.com',
  'watts-jp.myshopify.com',
  'wearhouse-com-au.myshopify.com',
  'waxing-kara.myshopify.com',
  'wedding-shoppe-inc.myshopify.com',
  'water-filters-fast.myshopify.com',
  'way-funky-deutschland.myshopify.com',
  'webblouse.myshopify.com',
  'website-test-1.myshopify.com',
  'west-coast-garage-2024.myshopify.com',
  'white-horse-vapor.myshopify.com',
  'wind-throttle.myshopify.com',
  'wild-poppies-nz.myshopify.com',
  'winesonlinenz.myshopify.com',
  'wishtrend-com.myshopify.com',
  'wine-vitage.myshopify.com',
  'wit-fitness.myshopify.com',
  'wohlfuehlprodukte.myshopify.com',
  'wonderland-us-shower-inc.myshopify.com',
  'wonderland-shower-inc.myshopify.com',
  'worthington-millwork.myshopify.com',
  'worldofluxuryus-1260.myshopify.com',
  'worldwide-floors.myshopify.com',
  'www-salonweardirect-co-uk.myshopify.com',
  'www-kidshoesdirect-com.myshopify.com',
  'xishina.myshopify.com',
  'www-entertainmentstore-in.myshopify.com',
  'www-vetniquelabs-com.myshopify.com',
  'www-rubaiyatfashion-com.myshopify.com',
  'xn-heubc2a1ener3d6eb2iqc6erfg0h4b1jmhe.myshopify.com',
  'xn-n8jvb278m3eo8wkgij61s.myshopify.com',
  'yogamii.myshopify.com',
  'xn-rss49j3pis1mu86b.myshopify.com',
  'ysa-jewelry-3628.myshopify.com',
  'zaff-light.myshopify.com',
  'zamst-canada.myshopify.com',
  'zenoni-colombi.myshopify.com',
  'zsiskadesign.myshopify.com',
  'zepbrook.myshopify.com',
  'zvoovfashion.myshopify.com'
];

export const WHITELIST_TURBO_V2_PRODUCTION = [
  'wish-rock-relaxation.myshopify.com',
  'solemateptyltd.myshopify.com',
  'sundae-muse.myshopify.com',
  'nobis-ca.myshopify.com',
  'nobis-us.myshopify.com',
  'indie-xo.myshopify.com',
  'kavkadesigns.myshopify.com',
  'loyallux.myshopify.com',
  'sugar-babies-childrens-boutique.myshopify.com',
  'patagonia-au.myshopify.com',
  'nobis-eu.myshopify.com',
  'the-rug-decor.myshopify.com',
  'patagonia-stage.myshopify.com',
  'endangered-trolls.myshopify.com',
  'citylux-boutique.myshopify.com',
  'mountaindog.myshopify.com',
  'creatisto.myshopify.com',
  'sand-dollar-dubai.myshopify.com',
  'greatlakescoin.myshopify.com',
  'shoesbank.myshopify.com',
  'nova-clothing-uk.myshopify.com',
  'chairlines.myshopify.com',
  'peter-murphy-electrical.myshopify.com',
  'snow-teeth-whitening.myshopify.com',
  'goldspot-pens.myshopify.com',
  'nobisinc.myshopify.com',
  'first-ever-nbl.myshopify.com',
  'urbanbliss-uk.myshopify.com',
  'isindia.myshopify.com',
  'flatironwines.myshopify.com',
  'nobis-uk.myshopify.com',
  'sole-mechanics-store.myshopify.com',
  'freddy-canada.myshopify.com',
  'sharpedge.myshopify.com',
  'howitzer-clothing.myshopify.com',
  'cater-equip.myshopify.com',
  'season-cookshop.myshopify.com',
  'apl-athletic-propulsion-labs.myshopify.com',
  'peekkids123.myshopify.com',
  'beyond-clothing-usa.myshopify.com',
  'boost-dev-app-v2-jason.myshopify.com',
  'lindyegalloway-staging.myshopify.com',
  'proven-winners-direct.myshopify.com',
  'moiongeorge.myshopify.com',
  'skin-brands.myshopify.com',
  'canada-gold-store.myshopify.com',
  'vidorshoes.myshopify.com',
  'rivendell-shop.myshopify.com',
  'mengloria.myshopify.com',
  'arthaussfurniture.myshopify.com',
  'smyth-jewelers.myshopify.com',
  'geartoroll.myshopify.com',
  'victorygemsandbeads.myshopify.com',
  'athlete-body.myshopify.com',
  'shoestore-tjinc.myshopify.com',
  'spa-order-store.myshopify.com',
  'swixsport.myshopify.com',
  'vintage-threads-store.myshopify.com',
  'nymphenburg.myshopify.com',
  'bambi-and-birdie.myshopify.com',
  'go-industrial.myshopify.com',
  'life-enhancement-products.myshopify.com',
  'holamatias.myshopify.com',
  'dardanos-shoes.myshopify.com',
  'art-spot-gallery.myshopify.com',
  'platini-fashion.myshopify.com',
  'lions-pride-plus.myshopify.com',
  'depofit-store.myshopify.com',
  'crystalboutiquearmagh.myshopify.com',
  'deeply-eu.myshopify.com',
  'lanctotteamsportsus.myshopify.com',
  'pila-rings.myshopify.com',
  'zahia-bvba.myshopify.com',
  'wc-productfiltersearch-teststore.myshopify.com',
  'hyperice-australia.myshopify.com',
  'wine-tasting-adventure.myshopify.com',
  'especiallyfor-mz.myshopify.com',
  'frisoren-baronen.myshopify.com',
  'sense-of-taste-liquor-stores.myshopify.com',
  'montaneuk.myshopify.com',
  'maintechconnect.myshopify.com',
  'nfhq.myshopify.com',
  'cherrykatestore.myshopify.com',
  'mila-m.myshopify.com',
  'starseed-collective.myshopify.com',
  'deeply-fr.myshopify.com',
  'deeply-pt.myshopify.com',
  'deeply-es.myshopify.com',
  'sweatbanddevclean.myshopify.com',
  'marjory-warren-boutique.myshopify.com',
  'caswells-fine-menswear-sale.myshopify.com',
  'think-vicci-eyewear.myshopify.com',
  'most-wanted-vintage.myshopify.com',
  'dangjane.myshopify.com',
  'balance-athletica.myshopify.com',
  'patagonia-nz.myshopify.com',
  'emptyvase.myshopify.com',
  'montane-us.myshopify.com',
  'montane-de.myshopify.com',
  'dts-westloop.myshopify.com',
  'nak-muay-training.myshopify.com',
  'bytestech.myshopify.com',
  'jollyjoystoys.myshopify.com',
  'nikin-dev21-02.myshopify.com',
  'thekayacollection.myshopify.com',
  'prestofit.myshopify.com',
  'tabletopnerdsdeals.myshopify.com',
  'lastikbox.myshopify.com',
  'minh-hau-store.myshopify.com',
  'verdipromesse.myshopify.com',
  'beermax.myshopify.com',
  'eltrebolprincipal.myshopify.com',
  'montane-dev.myshopify.com',
  'snow-tart.myshopify.com',
  'especiallyfor-test.myshopify.com',
  'afternoonlight.myshopify.com',
  'secondhandbags-ag.myshopify.com',
  'e-commerce-specialist-store-fany.myshopify.com',
  'test-filter-app.myshopify.com',
  'jaydenstarllc.myshopify.com',
  'meierotto-staging.myshopify.com',
  'demonocha.myshopify.com',
  'fg-dawn.myshopify.com',
  'custodian-streetwear.myshopify.com',
  'developmentikonity.myshopify.com',
  'green-and-wilds-retail.myshopify.com',
  'bouchier-test.myshopify.com',
  'green-man-wines.myshopify.com',
  'axessorize-1.myshopify.com',
  'mcwigs.myshopify.com',
  'hyperice-new-theme.myshopify.com',
  'her-and-earth.myshopify.com',
  'the-aromatherapy-co-nz.myshopify.com',
  'saysho-store.myshopify.com',
  'willis-sandwiches.myshopify.com',
  'modeon-streetwear.myshopify.com',
  'revolution-beauty-espana.myshopify.com',
  'salon-m-ec.myshopify.com',
  'carmarkt.myshopify.com',
  'al-gold-palace.myshopify.com',
  'dev-urbanwearonline.myshopify.com',
  'testsudaemuse.myshopify.com',
  'sorens-house.myshopify.com',
  'revolution-beauty-italia.myshopify.com',
  'lembergerland.myshopify.com',
  'pratyush-boost.myshopify.com',
  'keego-store.myshopify.com',
  'oinos-yorugos.myshopify.com',
  'aromatherapy-au.myshopify.com',
  'toyota-corolla-tokushima.myshopify.com',
  'lisle-chocolat.myshopify.com',
  'inspiredsilvercom.myshopify.com',
  'titan-fix.myshopify.com',
  'baby-jogger-canada.myshopify.com',
  'benzdiamonds.myshopify.com',
  'dzinehub-dev.myshopify.com',
  'authentically-american-llc.myshopify.com',
  'ssvworks.myshopify.com',
  'aqua-swim-supplies.myshopify.com',
  'rubyfox.myshopify.com',
  'ostens-fragrance.myshopify.com',
  'lovesewdev.myshopify.com',
  'apparel-leeds.myshopify.com',
  'gvalkov.myshopify.com',
  'test-nirnor.myshopify.com',
  'zoe-vine-co-uk.myshopify.com',
  'aspinwall.myshopify.com',
  'getgrapeful.myshopify.com',
  'hmstore123.myshopify.com',
  'luu-quang-tinh.myshopify.com',
  'rose-wardrobe.myshopify.com',
  'phil-o-sullivan-electrical.myshopify.com',
  'gyc-au.myshopify.com',
  'disc-golf-stars.myshopify.com',
  'blueboxdev.myshopify.com',
  'mydesigntheory.myshopify.com',
  'hush-puppiesde.myshopify.com',
  'strand-framing-stock.myshopify.com',
  'goodwillgo.myshopify.com',
  'doggiesolutions.myshopify.com',
  'mfwg.myshopify.com',
  'moroccan-carpet-company.myshopify.com',
  'thelogr.myshopify.com',
  'slowestore.myshopify.com',
  'thepanicroom-whl.myshopify.com',
  'beau-belle-chien.myshopify.com',
  'boss-corner-guards.myshopify.com',
  'choosit-dev-store-2.myshopify.com',
  'afkl-store.myshopify.com',
  'digital-mao-ecommerce-agency.myshopify.com',
  'musuvi.myshopify.com',
  'mon-by-mon-purse.myshopify.com',
  'jackiezstyle.myshopify.com',
  'ostens.myshopify.com',
  'bottles-fine-wine-llc.myshopify.com',
  'con-nois-seur-wine-imports.myshopify.com',
  'https-www-llbdshop-com.myshopify.com',
  'gyc-mower-depot.myshopify.com',
  'hanroau.myshopify.com',
  'footedshaft2.myshopify.com',
  'akoma-skincare.myshopify.com',
  'miskyra.myshopify.com',
  'repure.myshopify.com',
  'axis-parts.myshopify.com',
  'dz-pawmits.myshopify.com',
  'harvestimo-marketplace.myshopify.com',
  'order-of-style.myshopify.com',
  'bellezzacalma-admin.myshopify.com',
  'invisalign-store-test.myshopify.com',
  'rainforest-bowls.myshopify.com',
  'cnv-dev-store.myshopify.com',
  'self-portrait-2-0.myshopify.com',
  'great-british-interiors.myshopify.com',
  'forever-beauty-production.myshopify.com',
  'bottle-collective.myshopify.com',
  'bootheel-tractor.myshopify.com',
  'buddelhuus.myshopify.com',
  'dank-widget-store.myshopify.com',
  'moffett-sons.myshopify.com',
  'test-international-api.myshopify.com',
  'bao-theme-toolkit-parent.myshopify.com',
  'barnettsports.myshopify.com',
  'ucanda-ca.myshopify.com',
  'pacific-lab-products.myshopify.com',
  'plt-solutions.myshopify.com',
  'cowineshop.myshopify.com',
  'revolution-beauty-portugal.myshopify.com',
  'prime-bike-components.myshopify.com',
  'productos-jmvillegas.myshopify.com',
  'ashwinimulti.myshopify.com',
  'raw-apothecary-mx.myshopify.com',
  'kitchenallcom.myshopify.com',
  'check-filter971.myshopify.com',
  'optishop2.myshopify.com',
  'motorsport-freaks.myshopify.com',
  'deeply-europe.myshopify.com',
  'just-campagne-japan.myshopify.com',
  'houbidouwatch.myshopify.com',
  'tmf-mini.myshopify.com',
  'lerose-store.myshopify.com',
  'cbi-employee-store.myshopify.com',
  'mid-century-mobler-berkeley.myshopify.com',
  'brimandcap.myshopify.com',
  'arche-schue.myshopify.com',
  'annabeck.myshopify.com',
  'bike-ranch-online-store.myshopify.com',
  'schuhbidu-staging.myshopify.com',
  'fukayajustcampagne.myshopify.com',
  'doi-print.myshopify.com',
  'karendo.myshopify.com',
  'nikki-tibbles-wild-at-heart.myshopify.com',
  'di-jewellery.myshopify.com',
  'vcliveedge.myshopify.com',
  'pawmits.myshopify.com',
  'meat-n-bone-catering.myshopify.com',
  'shop-cbd-library.myshopify.com',
  'cf-hatimeria-demo.myshopify.com',
  'lb-h22-s01-e1.myshopify.com',
  'savransky-private-jeweler.myshopify.com',
  'gomx365b2b.myshopify.com',
  'lunabraclet.myshopify.com',
  'lb-h22-s01-e4.myshopify.com',
  'kanehide-online-store.myshopify.com',
  'gonature-wines.myshopify.com',
  'sole-distribution-shoes.myshopify.com',
  'sole-distribution-nz.myshopify.com',
  'hais-demo.myshopify.com',
  'domenica-col.myshopify.com',
  'charlotte-sayers.myshopify.com',
  'brightfield-dev.myshopify.com',
  'develop-goldmarket.myshopify.com',
  'demo-rachel-galley.myshopify.com',
  'studieag.myshopify.com',
  'slenderella-ltd.myshopify.com',
  'endurobearings-com.myshopify.com',
  'monarch-wine-merchants.myshopify.com',
  'nellacutlery.myshopify.com',
  'xn-hxtulg0yk0d491c.myshopify.com',
  'artknit-studios-test.myshopify.com',
  'invade-testing.myshopify.com',
  'turquoiseoficial.myshopify.com',
  'mangaoriginal.myshopify.com',
  'casualbasement.myshopify.com',
  'totalrepro.myshopify.com',
  'bethrifty-events.myshopify.com',
  'bethrifty-vintage-fashion-store.myshopify.com',
  'crown1500.myshopify.com',
  'electronic-vehicules.myshopify.com',
  'igniteage.myshopify.com',
  'patchwerks.myshopify.com',
  'milkshakeusa.myshopify.com',
  'emerald-doors-sandbox.myshopify.com',
  'colorcrack-dev2.myshopify.com',
  'shella-1.myshopify.com',
  '8com-limited.myshopify.com',
  'pro-sportswear-store.myshopify.com',
  'bojo-kids.myshopify.com',
  'lone-wolf-paintball-online-store.myshopify.com',
  'mystore111298.myshopify.com',
  'uae-maje.myshopify.com',
  'barnettspain.myshopify.com',
  'internal-test-frenzy.myshopify.com',
  'kimonoyarn.myshopify.com',
  'tris-test.myshopify.com',
  'salvo-store-hk.myshopify.com',
  'mynailcrush.myshopify.com',
  'muscle-republic.myshopify.com',
  'dev-aiatsis.myshopify.com',
  'shop-koe.myshopify.com',
  'responsible-last-chance.myshopify.com',
  'freak-code.myshopify.com',
  'benkei-hime.myshopify.com',
  'springfield-ksa.myshopify.com',
  'stonethecrowsretail.myshopify.com',
  'jinsoon.myshopify.com',
  'sheilachenart.myshopify.com',
  'appliance-deals-admin.myshopify.com',
  'ryui-store.myshopify.com',
  'redcollectors.myshopify.com',
  'umauma-online.myshopify.com',
  'altruesm.myshopify.com',
  'wfsweb.myshopify.com',
  'green-and-wilds-trade.myshopify.com',
  'flimbosstore.myshopify.com',
  'puurwijn.myshopify.com',
  'dev-pdm-connector-2.myshopify.com',
  'worldbuildersmarket.myshopify.com',
  'jamaleqt.myshopify.com',
  'fashion2loveinc.myshopify.com',
  'uturn-australia.myshopify.com',
  'tesst-pdm-1.myshopify.com',
  'xn-feue1a6ea3grab7u.myshopify.com',
  'shoptherag-2.myshopify.com',
  'supesuclothing.myshopify.com',
  'zone3-black-friday.myshopify.com',
  'circle-shop-avignon.myshopify.com',
  'joya-caserta.myshopify.com',
  'prosketchingdev.myshopify.com',
  'partyonlinenz.myshopify.com',
  'oncueapparel.myshopify.com',
  'rody-store-new.myshopify.com',
  'sale-master-dev-2.myshopify.com',
  'longerchainsaws-com-au.myshopify.com',
  'mad-kicks-store.myshopify.com',
  'off-road-obsessions-2.myshopify.com',
  'luxury-jewels-of-st-leon.myshopify.com',
  'everytool-uk.myshopify.com',
  'hjem-bord.myshopify.com',
  'peakperformance-jp.myshopify.com',
  'vitame-skincare.myshopify.com',
  'larsondoors.myshopify.com',
  'recycled-toner-onlinestore.myshopify.com',
  'cysbeauty.myshopify.com',
  'luxurylig.myshopify.com',
  'lifelystore.myshopify.com',
  'zone3-us.myshopify.com',
  'emerald-doors-ltd.myshopify.com',
  'zone-3-eu.myshopify.com',
  'la-dress-toulon.myshopify.com',
  'xn-cckdaxd1gzeti5cxec.myshopify.com',
  'shop-of-hokusai.myshopify.com',
  'daniel-molina-dev.myshopify.com',
  'masterpro-spain.myshopify.com',
  'wristcake.myshopify.com',
  'twistedalchemy.myshopify.com',
  'scanteak-my.myshopify.com',
  'dangoproducts.myshopify.com',
  'sap4x4.myshopify.com',
  'capacitacion-iris-collection1.myshopify.com',
  'wallflower-jeans.myshopify.com',
  'my-rug-source.myshopify.com',
  'kane-develop.myshopify.com',
  'capacitacion-iris-homepage5.myshopify.com',
  'just-a-test-dev-store.myshopify.com',
  'duroflex-world.myshopify.com',
  'mairam-growave2.myshopify.com',
  'misfit-world-meets.myshopify.com',
  'kynora-malaysia.myshopify.com',
  'manada2.myshopify.com',
  'locknlube.myshopify.com',
  'she-hair-extension-pro.myshopify.com',
  'perfumes-5071.myshopify.com',
  'love-noel-jewelry.myshopify.com',
  'touseef007.myshopify.com',
  'oldfisherbags-com.myshopify.com',
  'pitbull-california.myshopify.com',
  'huippukivacom.myshopify.com',
  'lifesort.myshopify.com',
  'testdundondundon.myshopify.com',
  'sparky-online-store.myshopify.com',
  'gottamexico.myshopify.com',
  'byapple.myshopify.com',
  'hayan-skincare.myshopify.com',
  'newrycomputercentre.myshopify.com',
  'bulbheadstore2.myshopify.com',
  'manadacl.myshopify.com',
  'ecl-store-ph.myshopify.com',
  'cs-polarn.myshopify.com',
  'mix-bmw.myshopify.com',
  'sh2022-test.myshopify.com',
  'tablemark-prd.myshopify.com',
  'bl-demo-2022.myshopify.com',
  'hw-shopstore.myshopify.com',
  'vonzweiterhand-ch.myshopify.com',
  'remate-muebles-oficina.myshopify.com',
  'invisalign-store-uk-test.myshopify.com',
  'thehomeedit-store.myshopify.com',
  'moto-jewelry2020.myshopify.com',
  'nahgimas-shoes.myshopify.com',
  'chewy-chews1.myshopify.com',
  'sunoh-learning.myshopify.com',
  'boostcommerse.myshopify.com',
  'osprey-tienda.myshopify.com',
  'plantur-39-au.myshopify.com',
  'lasportiva-shop.myshopify.com',
  'qualitytapestries.myshopify.com',
  'hhzjex.myshopify.com',
  'shop-hydroflask.myshopify.com',
  'nr-test-ec.myshopify.com',
  'tablemark-stg.myshopify.com',
  'trk-parts.myshopify.com',
  'opposite-wall.myshopify.com',
  'thegardenspace.myshopify.com',
  'sample-udemy-app-store-1.myshopify.com',
  'korda-shop-demo.myshopify.com',
  'oliver-brown-2022.myshopify.com',
  'luckies-uk.myshopify.com',
  'babf-test.myshopify.com',
  'nattou.myshopify.com',
  'glowmode.myshopify.com',
  'cdsvinyljapanstore.myshopify.com',
  'lisa-maree-boutique.myshopify.com',
  'brokenenglishjewelry.myshopify.com',
  'shop-the-pines.myshopify.com',
  'firedeptcoffee-com.myshopify.com',
  'milamore-en.myshopify.com',
  'gallery-funaki-staging.myshopify.com',
  'shiundo-sample.myshopify.com',
  'support-8870.myshopify.com',
  'scorpionwebshop.myshopify.com',
  'dev-localdemo.myshopify.com',
  'rgb-lighting-inc.myshopify.com',
  'alpecin-au.myshopify.com',
  'ghelcoiffeur.myshopify.com',
  'mensland-dev.myshopify.com',
  'hz-hair.myshopify.com',
  'buckleback-archive.myshopify.com',
  'make-up-for-professionals.myshopify.com',
  'namilia2.myshopify.com',
  'gerards-cosmetic-culture.myshopify.com',
  'nyd-store.myshopify.com',
  'invisalign-store-au.myshopify.com',
  'warm-nordic.myshopify.com',
  'invisalign-germany.myshopify.com',
  'canvas-demo-store.myshopify.com',
  'oh-my-melt.myshopify.com',
  'b2b-belmanetti.myshopify.com',
  'bulkwildflowers.myshopify.com',
  'bauerfeind-dev.myshopify.com',
  'www-ratatone-com.myshopify.com',
  'tokitoki-test.myshopify.com',
  'all-things-web-dev-environment.myshopify.com',
  'house-home-more.myshopify.com',
  'ove-decors-costco-next.myshopify.com',
  'maxamp.myshopify.com',
  'hamilton-insignia.myshopify.com',
  'cine-grail.myshopify.com',
  'viaromashop.myshopify.com',
  'zuty-austria.myshopify.com',
  'koenner-soehnen.myshopify.com',
  'she-espana-22.myshopify.com',
  'skinbyolga-dev.myshopify.com',
  'thelinebyk.myshopify.com',
  'tequila-nectars.myshopify.com',
  'wine-backstreet.myshopify.com',
  'cherie-amour-intimates.myshopify.com',
  'fisher-man-best.myshopify.com',
  'dromgooles2.myshopify.com',
  'capacitacion-qa-store-1.myshopify.com',
  'thebladerunnernewcastle.myshopify.com',
  'zachhoff-001.myshopify.com',
  'white-story.myshopify.com',
  'co-mac.myshopify.com',
  'castors-cart.myshopify.com',
  'mmus-demo.myshopify.com',
  'itsmywallstore.myshopify.com',
  'invisalign-italy.myshopify.com',
  'plants-n-petals.myshopify.com',
  'clique2022.myshopify.com',
  'my-cup-2.myshopify.com',
  'shopa-baby.myshopify.com',
  'dpolizanov-learning.myshopify.com',
  'hotheadz-diecast.myshopify.com',
  'golf-cart-geeks.myshopify.com',
  'amandacom.myshopify.com',
  'namila-us.myshopify.com',
  'zuty-romania.myshopify.com',
  'hh-promotions.myshopify.com',
  'green-and-wilds-test.myshopify.com',
  'arrowhead-kred.myshopify.com',
  'akimsemka20013007.myshopify.com',
  'dallas-8552.myshopify.com',
  'sanitasskincare.myshopify.com',
  'carpetsindia.myshopify.com',
  'amani-fashion-v1.myshopify.com',
  'ocean-acaju.myshopify.com',
  'mycup-co-nz.myshopify.com',
  'zuty-spain.myshopify.com',
  'calitrovestore.myshopify.com',
  'laxus-dev.myshopify.com',
  'plugin-frenzy-try1.myshopify.com',
  'borbonese-code-testing.myshopify.com',
  'bulkseedstore.myshopify.com',
  'diamondi-de.myshopify.com',
  'trend-telecom-inc.myshopify.com',
  '718autoperformance.myshopify.com',
  'jngl-online.myshopify.com',
  'wanderwuuds.myshopify.com',
  'sani-tech-ca.myshopify.com',
  'invisalign-store-jp.myshopify.com',
  'enichi-offer.myshopify.com',
  'dynamics-sync-test.myshopify.com',
  'ylanga-paris.myshopify.com',
  'jhar-test.myshopify.com',
  'goodfoodproject.myshopify.com',
  'kelvins-test.myshopify.com',
  'curated-spaces-melbourne.myshopify.com',
  'collectors1946-huntington.myshopify.com',
  'workwear-and-safety-warehouse.myshopify.com',
  'wines-direct-irl.myshopify.com',
  'alexander-sparks-store.myshopify.com',
  'gorillaoffroad.myshopify.com',
  'myjamstore-test.myshopify.com',
  'apriori-groningen.myshopify.com',
  'zuty-bulgaria.myshopify.com',
  'pixelboys.myshopify.com',
  'wilsons-square.myshopify.com',
  'thebikestudio.myshopify.com',
  'caster-central-new-web.myshopify.com',
  'test-fujimoto.myshopify.com',
  'cc-uk-demo.myshopify.com',
  'mar-soreli.myshopify.com',
  'coconutpops.myshopify.com',
  'store-tokichi-en.myshopify.com',
  'desa3.myshopify.com',
  'coffee-outdoors.myshopify.com',
  'skynon.myshopify.com',
  'canvasprintscom.myshopify.com',
  'giga-site-ca.myshopify.com',
  'sanignacio-es.myshopify.com',
  'milkshakepro.myshopify.com',
  'page-builder-jen.myshopify.com',
  'webentialdemo.myshopify.com',
  'robe-shoe.myshopify.com',
  'edev2.myshopify.com',
  'dz-jewels4life.myshopify.com',
  'comebackvinyl.myshopify.com',
  'kaiser-4645.myshopify.com',
  'netko-solution-demo.myshopify.com',
  'factory-ride-eu.myshopify.com',
  'torekore.myshopify.com',
  'livingwell-7543.myshopify.com',
  'bion-sg.myshopify.com',
  'tsunetani.myshopify.com',
  'loca-art-usa-two-marshmallows-llc.myshopify.com',
  'shop-chain-link.myshopify.com',
  'the-crafted-prints.myshopify.com',
  'tien-ho.myshopify.com',
  'fresh-society-co.myshopify.com',
  'clear-skinz-frame-protection-film.myshopify.com',
  'ronde038.myshopify.com',
  'xn-bck1b9a5dre4c6b6890bcuqrx6hizzb.myshopify.com',
  '4ocean.myshopify.com',
  'jins-playground-2022.myshopify.com',
  'collectors-massapequa.myshopify.com',
  'celebourg.myshopify.com',
  'sydney-luggage.myshopify.com',
  'herorajewellery.myshopify.com',
  'zt-labels.myshopify.com',
  'bd4412.myshopify.com',
  'meg-liz-swim.myshopify.com',
  'todotops-cl.myshopify.com',
  'tci-newtest2.myshopify.com',
  '100wdev.myshopify.com',
  'gulvstore.myshopify.com',
  'apl-sandbox-23.myshopify.com',
  'salvage-renaissance-2463.myshopify.com',
  'loqi-b2b-us.myshopify.com',
  'shady-rays-glasses.myshopify.com',
  'onlystores-de.myshopify.com',
  'diamondi-ro.myshopify.com',
  'meganestore-dev.myshopify.com',
  'www-jewels4life-com.myshopify.com',
  'nagayatest-sauna.myshopify.com',
  'plantgem.myshopify.com',
  'linen-for-littles.myshopify.com',
  'gooding-io.myshopify.com',
  'diamondi-bg.myshopify.com',
  'xn-eck7an3jne.myshopify.com',
  'newpermission-pixel.myshopify.com',
  'd5a0da.myshopify.com',
  'skyfalltest-dev.myshopify.com',
  'notebuk.myshopify.com',
  'felice-lifedesign.myshopify.com',
  'kurashikihampu-store.myshopify.com',
  'dookan-theme-development.myshopify.com',
  'lullabellz.myshopify.com',
  'bowtiespearls.myshopify.com',
  'test-app-cde.myshopify.com',
  'noamk.myshopify.com',
  'steel-toe-studios.myshopify.com',
  'baseball-park-stand-in.myshopify.com',
  'destinationfabrics.myshopify.com',
  'howler-bike-co.myshopify.com',
  'alivetest230123-sauna-select.myshopify.com',
  'mad-kicks-staging-store.myshopify.com',
  'chaosfx.myshopify.com',
  'hamaya-jt-dev-at.myshopify.com',
  'betts-au.myshopify.com',
  'green-canvas-farms.myshopify.com',
  'siobhan-collopy.myshopify.com',
  'captain-frothbeard.myshopify.com',
  'cart-drawer01.myshopify.com',
  'enen-store.myshopify.com',
  'curtainstarps.myshopify.com',
  'happy-buy-cosme.myshopify.com',
  'kemuja.myshopify.com',
  'sauna-select.myshopify.com',
  'travis-test-2.myshopify.com',
  'yoki-japaneseshop.myshopify.com',
  'mhdez-sticky-store.myshopify.com',
  'oioioidev.myshopify.com',
  'everactive-online.myshopify.com',
  'skeellertest.myshopify.com',
  'emmalysdk.myshopify.com',
  'luoluo-style.myshopify.com',
  'mapleprime.myshopify.com',
  'tabletop-nikko.myshopify.com',
  'fotl-b2b.myshopify.com',
  'taburo-webstore.myshopify.com',
  'ryui-store-en.myshopify.com',
  'dardanoplustest.myshopify.com',
  'travis-test-5.myshopify.com',
  'xn-cck2ba4clb3897eu94e.myshopify.com',
  'xtianah.myshopify.com',
  'mad-kicks-saudi-arabia.myshopify.com',
  'annette-undheim.myshopify.com',
  'amarosa-home.myshopify.com',
  '7dd661.myshopify.com',
  'valencia-saddlery.myshopify.com',
  'y1-digital.myshopify.com',
  'gettingstartedthemekit.myshopify.com',
  'test-shopee-123.myshopify.com',
  'gigate-ksa.myshopify.com',
  'test-appext-sparq.myshopify.com',
  'test03072023.myshopify.com',
  'sivaguru-vjro.myshopify.com',
  'monkeeroos-store.myshopify.com',
  'dsupplied1.myshopify.com',
  'wilsonsportsme.myshopify.com',
  'siyanthan-store.myshopify.com',
  '3b6dbb.myshopify.com',
  'zildjianshop.myshopify.com',
  'xn-2-zn8av59a76v.myshopify.com',
  'us-lullabellz.myshopify.com',
  'nella-wholesale.myshopify.com',
  'superba-dev.myshopify.com',
  'plobalapps-qa-5.myshopify.com',
  'bion-my.myshopify.com',
  'commercial-sandbox.myshopify.com',
  'dishgirl.myshopify.com',
  'willies-dev.myshopify.com',
  'tmtesting345.myshopify.com',
  'fatefull.myshopify.com',
  'fruitloops-kitesurfing-school.myshopify.com',
  'bolighusetwerenberg.myshopify.com',
  'maje-ksa.myshopify.com',
  'nikko-tabletop-dev.myshopify.com',
  'professional-sanitas.myshopify.com',
  'oliver-brown-usa.myshopify.com'
];

export function isInWhiteListTurbo(tenantId: string) {
  const whitelist =
    process.env.REACT_APP_ENV === 'staging' ? WHITELIST_TURBO_STAGING : WHITELIST_TURBO_PRODUCTION;
  return whitelist.includes(tenantId);
}

export function isInWhiteListTurboV2(tenantId: string) {
  const whitelist =
    process.env.REACT_APP_ENV === 'staging'
      ? WHITELIST_TURBO_V2_STAGING
      : WHITELIST_TURBO_V2_PRODUCTION;
  return whitelist.includes(tenantId);
}

// https://clearerio.atlassian.net/browse/BC-6209
export function isInWhiteListTurboBanner(tenantId: string) {
  const whitelist =
    process.env.REACT_APP_ENV === 'staging'
      ? WHITELIST_TURBO_BANNER_STAGING
      : WHITELIST_TURBO_CAMPAIGN_PRODUCTION;
  return whitelist.includes(tenantId) && isInTimeRangeCampaign();
}

export function isInTimeRangeCampaign() {
  const today = moment();
  const isBetweenTimeRangeTurboCampaign =
    process.env.REACT_APP_ENV === 'staging'
      ? true
      : today.isSameOrAfter(turboCampaignStart, 'day') &&
        today.isSameOrBefore(turboCampaignEnd, 'day');
  return isBetweenTimeRangeTurboCampaign;
}

export const turboCampaignStart = moment('15/04/2025', 'DD/MM/YYYY'); // Time campaign production
export const turboCampaignEnd = moment('05/05/2025', 'DD/MM/YYYY'); // Time campaign production
